import { render, staticRenderFns } from "./CardErrors.vue?vue&type=template&id=5be96aec&scoped=true&"
import script from "./CardErrors.vue?vue&type=script&lang=js&"
export * from "./CardErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be96aec",
  null
  
)

export default component.exports